// extracted by mini-css-extract-plugin
module.exports = {"add_icon":"DiscountChip_add_icon__k6oMm","discount-text":"DiscountChip_discount-text__VNwPK","multiple-discount":"DiscountChip_multiple-discount__1kuom"};